<template>
  <portlet
          :icon="'fad fa-mobile'"
          :title="name"
          :actionsBlock="true"
  >
    <template slot="portletBody">
      <div class="category-container row" style="margin-bottom: 1.5rem">
        <div class="col-10">
            <section-menu 
            :menu="menu" 
            :entry="menuEntry"
            @entryClick="menuClick($event)">
        </section-menu>
        </div>
      </div>
      <hr/>
      <div class="category-container row" v-if="Can(rights.LEAVEREQUESTS_VIEW)">
        <div class="col-10">
            <div class="row">
                <div :class="getCategoryClass(forCategory)" v-for="(forCategory, key) in categories" v-bind:key="key" @click="categoryClick(forCategory)">
                    {{ forCategory.name }}
                </div>
            </div>
        </div>
        <div class="col-2">
            <div class="row justify-content-end">
                <div :class="getYearClass(forYear) + ' float-right'" v-for="forYear, key in years" v-bind:key="key" @click="yearClick(forYear)">
                    {{ forYear }}
                </div>
            </div>
        </div>
      </div>
      <div class="documents-container row" v-if="Can(rights.LEAVEREQUESTS_VIEW)">
        <table class="table-list-h" style="width: 100%; border-spacing: 0">
            <thead>
                <tr>
                    <th>Manager</th>
                    <th>State</th>
                    <th>Subject</th>
                    <th>Date</th>
                    <th>Message</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr :class="getRowClass(leaveRequest)" v-for="leaveRequest in leavesOfYearAndStatus()" @click="selectedLeaveRequest = leaveRequest" v-bind:key="leaveRequest.id" data-target="#leave-request-modal" data-toggle="modal" style="cursor: pointer">
                    <td style="padding-right: 0">
                        <div style="border: 2px solid; border-radius: 10px 0 0 10px; border-right: none;">
                            {{ employment ? employment.client : '-'}}
                        </div>
                    </td>
                    <td style="padding-left: 0; padding-right: 0;">
                        <div class="capitalized" style="border: 2px solid; border-radius: 0; border-right: none; border-left: none;">
                            {{ leaveRequest.status }}
                        </div>
                    </td>
                    <td style="padding-left: 0; padding-right: 0;">
                        <div style="border: 2px solid; border-radius: 0; border-right: none; border-left: none;">
                            Leave Request
                        </div>
                    </td>
                    <td style="padding-left: 0; padding-right: 0;">
                        <div style="border: 2px solid; border-radius: 0; border-right: none; border-left: none;">
                            {{ getDateFormatted(leaveRequest) }} ({{ leaveRequest.hours }} hours)
                        </div>
                    </td>
                    <td style="padding-left: 0; padding-right: 0;">
                        <div style="border: 2px solid; border-radius: 0; border-right: none; border-left: none;">
                            {{ leaveRequest.reason ? leaveRequest.reason : '-'}}
                        </div>
                    </td>
                    <td style="padding-left: 0;">
                        <div style="border: 2px solid; border-radius: 0 10px 10px 0; border-left: none;">
                            <span style="border: 2px solid; border-radius: 20px; padding: 2px 7px">
                                <i class="fa fa-arrow-right"></i>
                            </span>
                        </div>
                    </td>
                </tr>
                
            </tbody>
        </table>
        <leave-request-modal
            v-if="true"
            :value="{name: '', rights: []}"
            :name="'leave-request-modal'"
            :title="'Leave request: ' + name"
            :leaveRequest="selectedLeaveRequest"
            @saveChanges="updateLeaveRequest($event)"
        >
        </leave-request-modal>
      </div>
      <div v-else>No rights</div>
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {dataTables} from '../../components/mixins/dataTables.js';
  import {swalModals} from '../../components/mixins/swalModals.js';
  import Vue from 'vue';
  import store from '../../store.js';
  import document from '../../components/documents/document.vue';
  import { Can } from '../../../permission/ability.js';
  import sectionMenu from '../../components/documents/sectionMenu.vue'
  import leaveRequestModal from '../../components/leave-requests/leaveRequestModal.vue'
  import { RIGHTS } from '../roles/rights';

  export default {
  components: { document, sectionMenu, leaveRequestModal },
    mixins: [dataTables, swalModals],
    data() {
      return {
        rights: {},
        id: '',
        name: '',
        isAdmin: false,
        documents: [],
        categories: [{name: 'All', id: 'all'}, {name: 'Approved', id: 'approved'}, {name: 'Rejected', id: 'rejected'}, {name: 'Pending', id: 'pending'}],
        years: [],
        year: null,
        category: {name: 'Pending', id: 'pending'},
        employment: null,
        menuEntry: {id:1, name: 'Pending'},
        leaveRequests: [],
        menu: [{name: 'Leave', id: 1}, {name: 'Documents', id: 2}, {name: 'Archived chats', id: 3}],
        selectedLeaveRequest: {}
      };
    },
  async   created() {
      this.rights = RIGHTS;
      this.$store.commit('setLoading',true)
      this.id = parseInt(this.$route.params.employment)
      //this.category = parseInt(this.$route.params.category)
      this.name = this.$route.params.name
      await  this.fetchData();
      this.$store.commit('setLoading',false)
      this.isAdmin = this.$store.state.users.me.admin;

      if(this.employment === null || this.employment.id !== this.id) {
        let employment = this.getEmployment
        if(employment.id === undefined || employment.id !== this.id) {
            store.dispatch('employments/get', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, employment_id: this.id}).then((res) => {
                if (res.status === 200) {
                    this.employment = res.data.data
                }
            }).catch((err) => {
                alert('Unexpected error downloading employments')
            });

        }
      }
    },
    methods: {
      Can,
      async  fetchData() {
        this.$store.commit('setLoading',true)

        store.dispatch('leaveRequests/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments}).then((res) => {
          if (res.status === 200) {
            let leaveRequests = res.data.data
            this.leaveRequests = leaveRequests.filter((leaveRequest) => {
                return leaveRequest.employment_id === this.id
            })

            let years = []
            this.leaveRequests.map((document, key) => {
                // Index by employment id
                let year = moment(document.date, "YYYY-MM-DD").year()
                
                if(!years.includes(year)) {
                    years.push(year)
                }
            })

            years.sort()
            this.years = years
            this.year = this.years[0]
          }
        }).catch((err) => {
            alert('Unexpected error with leave requests')
        });

        this.$store.commit('setLoading',false)
      },
      updateLeaveRequest(leaveRequest) {
        store.dispatch('leaveRequests/update', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, id: leaveRequest.id, leaveRequest: leaveRequest}).then((res) => {
            if (res.status === 200) {
                this.$swal({
                    title: "Success!",
                    html: 'Leave request updated correctly',
                    type: "info",
                    confirmButtonText: 'Oké',
                    reverseButtons: true,
                }).then(() => {
                    this.fetchData()
                })
            }
        }).catch((err) => {
            alert('Unexpected error uploading the document')
        });
      },
      getRowClass(leaveRequest) {
        return 'col-12 ' + leaveRequest.status
      },
      getDateFormatted(leaveRequest) {
        return moment(leaveRequest.date, "YYYY-MM-DD").format('DD MMMM YYYY')
      },
      setFile(e) {
        if(e.target.files && e.target.files.length > 0) {
            this.file = e.target.files[0]
        } else {
            this.file = null
        }
        
      },
      menuClick(event) {
        this.menuEntry = event
        switch(event.id) {
            case -1:
                this.$router.push('/hours')
            break;
            case 1:
                this.$router.push('/leave-requests/' + this.id + '/' + this.name)
            break;
            case 2:
                this.$router.push('/documents/' + this.id + '/1/' + this.name)
            break;
            case 3:
                this.$router.push('/archived-chats/' + this.id + '/' + this.name)
            break;
        }
      },
      getYear(leaveRequest) {
        return moment(leaveRequest.date, 'YYYY-MM-DD').year()
      },
      yearClick(year) {
        this.year = year
      },
      getYearClass(year) {
        return year === this.year ? 'year-widget active' : 'year-widget'
      },
      categoryClick(category) {
        this.category = category
      },
      getCategoryClass(category) {
        return category.id === this.category.id ? 'sub-category-widget active' : 'sub-category-widget'
      },
      getCategory(document) {
        return document.category.id
      },
      getStatus(leaveRequest) {
        return leaveRequest.status
      },
      leavesOfYearAndStatus() {
        // Filter leave requests of the current year
        let t = this.leaveRequests.filter((leaveRequest, key) => {
            if(this.year === this.getYear(leaveRequest) && (this.category.id === 'all' || this.category.id === this.getStatus(leaveRequest))) {
                return leaveRequest;
            }
        })
        return t
      }
    },
    computed: {
      ...mapGetters('roles', ['getRoles']),
      ...mapGetters('employments', [
          'getEmployment'
        ]),
    },
    watch: {
        file(newV, oldV) {
            if(newV !== null) {
                $('.modal').modal('show') ;
            }
        }
    }
  };
</script>

<style lang="scss" scoped>
    .table-list-h {
        .rejected {
            div {
                background-color: #F5CECE;
            }
            color: #D32F2F;
        }
        .approved {
            div {
                background-color: #E5EEF7;
            }
            color: #146F70;
        }
        .pending {
            div {
                background-color: #FBF1EA;
            }
            color: #FF924E;
        }
        th {
            text-align: center;
        }
        td {
            text-align: center;
            div {
                padding: 10px 14px;
                margin-bottom: 1rem;
            }
            .capitalized {
                text-transform: capitalize;
            }
        }
    }
</style>